export enum NavigationTypes {
  PENDING = 0,
  NAVIGATION_PANEL = 1,
  OTHER = 2,
}
